import type { Revision, RevisionPageDocument, RevisionVariableValue } from '../../types';
import { mutations } from '../../utils';

/**
 * Get the value of a variable on a revision.
 */
export function getRevisionVariable(
    revision: mutations.MutableData<Revision>,
    fieldName: string
): RevisionVariableValue | undefined {
    return getVariable(revision, fieldName);
}

/**
 * Get the value of a variable on a page.
 */
export function getRevisionPageVariable(
    page: mutations.MutableData<RevisionPageDocument>,
    fieldName: string
): RevisionVariableValue | undefined {
    return getVariable(page, fieldName);
}

function getVariable(
    obj: mutations.MutableData<Revision | RevisionPageDocument>,
    fieldName: string
): RevisionVariableValue | undefined {
    // @ts-ignore
    return mutations.getIn(obj, ['variables', fieldName] as const);
}
